<template>
    <div>
        <div class="slbWarning-title">
        	<Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/network/slbMonitor">{{ $t('alarms.network.loadBalancing.loadBalancing') }}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.alertRule') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="slbWarning-top">
                        <slb-warning-search></slb-warning-search>
                    </div>
                    <table-slb-warning></table-slb-warning>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import SlbWarningSearch from '../slb/SlbWarningSearch'
    import TableSlbWarning from '../slb/TableSlbWarning'

    export default {
        name: 'SlbWarning',
        components: {
            SlbWarningSearch,
            TableSlbWarning
        },
        data(){
            return {
                id:'',
                accountId:'',
                loadbalancerId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                name:'',
                loadbalancerType:'',
                loadBalancerArn:'',
                monitorModule: ''
            }
        },
         methods:{
            // 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.loadbalancerId=this.$route.query.loadbalancerId;
                this.region=this.$route.query.region;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.loadbalancerType=this.$route.query.loadbalancerType;
                this.loadBalancerArn=this.$route.query.loadBalancerArn;
                this.monitorModule=this.$route.query.monitorModule;
                this.$router.push({path:'/network/slbDetail/',
                  query: {
                  id: this.id,
                    accountId:this.accountId,
                    loadbalancerId:this.loadbalancerId,
                    region:this.region,
                    accountTypeName:this.accountTypeName,
                    accountName:this.accountName,
                    name:this.name,
                    loadbalancerType:this.loadbalancerType,
                    loadBalancerArn:this.loadBalancerArn,
                    monitorModule:this.monitorModule
                }});
            }
        }
    }
</script>

<style scoped>
    .slbWarning-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .slbWarning-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/slb/SlbWarning.vue